import { Candidate, InterviewItem, InterviewListItem } from '../types';
import { ATS_CONSTANTS } from '../constants';

// Type Guards
export const isCandidate = (item: InterviewItem): item is Candidate => {
  return item?.kind === 'candidate';
};

export const isInterviewListItem = (item: InterviewItem): item is InterviewListItem => {
  return item?.kind === 'interview-list-item';
};

// Status Helpers
export const getStatusColor = (status: string): string => {
  switch (status) {
    case ATS_CONSTANTS.STATUS.ACCEPTED:
    case ATS_CONSTANTS.STATUS.COMPLETED:
      return ATS_CONSTANTS.COLORS.SUCCESS;
    case ATS_CONSTANTS.STATUS.REJECTED:
    case ATS_CONSTANTS.STATUS.CANCELLED:
    case ATS_CONSTANTS.STATUS.NO_SHOW:
    case ATS_CONSTANTS.STATUS.EXPIRED:
      return ATS_CONSTANTS.COLORS.ERROR;
    case ATS_CONSTANTS.STATUS.SCHEDULED:
    case ATS_CONSTANTS.STATUS.RESCHEDULED:
    case ATS_CONSTANTS.STATUS.VIEWED:
      return ATS_CONSTANTS.COLORS.INFO;
    case ATS_CONSTANTS.STATUS.GENERATED:
      return ATS_CONSTANTS.COLORS.GRAY;
    default:
      return ATS_CONSTANTS.COLORS.GRAY;
  }
};

export const getStatusLabel = (status: string): string => {
  return status.replace(/_/g, ' ');
};

export type AtsAction = 'SCHEDULE_INTERVIEW' | 'REJECT' | 'GENERATE_OFFER' | 'RESCHEDULE' | 'CANCEL' | 'MARK_COMPLETED' | 'MARK_NO_SHOW' | 'DOWNLOAD_OFFER';

export const getAvailableActions = (candidate: InterviewItem): AtsAction[] => {
  const actions: AtsAction[] = [];

  if (isCandidate(candidate)) {
    const { column, interviewDetails, offerLetter } = candidate;

    switch (column) {
      case ATS_CONSTANTS.COLUMNS.APPLIED:
        actions.push('SCHEDULE_INTERVIEW');
        actions.push('REJECT');
        break;

      case ATS_CONSTANTS.COLUMNS.IN_CONSIDERATION:
        const status = interviewDetails?.status || ATS_CONSTANTS.STATUS.SCHEDULED;
        actions.push('REJECT');

        if (status === ATS_CONSTANTS.STATUS.COMPLETED) {
          if (!offerLetter) {
            actions.push('GENERATE_OFFER');
          }
        } else if (status === ATS_CONSTANTS.STATUS.SCHEDULED || status === ATS_CONSTANTS.STATUS.RESCHEDULED) {
          actions.push('RESCHEDULE');
          actions.push('CANCEL');
        } else if (status === ATS_CONSTANTS.STATUS.NO_SHOW || status === ATS_CONSTANTS.STATUS.CANCELLED) {
          actions.push('RESCHEDULE');
        }
        break;

      case ATS_CONSTANTS.COLUMNS.ACCEPTED:
        if (offerLetter) {
          actions.push('DOWNLOAD_OFFER');
        }
        break;

      case ATS_CONSTANTS.COLUMNS.REJECTED:
        // No actions typically, maybe 'Reconsider' in future
        break;
    }
  } else if (isInterviewListItem(candidate)) {
    const { interviewDetails } = candidate;
    const status = interviewDetails.status || ATS_CONSTANTS.STATUS.SCHEDULED;

    if (status === ATS_CONSTANTS.STATUS.SCHEDULED || status === ATS_CONSTANTS.STATUS.RESCHEDULED) {
      actions.push('RESCHEDULE');
      actions.push('CANCEL');
    }
  }

  return actions;
};
